export const ANALYTICS_GOALS = {
    REGISTRATION: 'registration',
    CLICK_REGISTRATION: 'click_registration',
    CLICK_COMPRA_AHORA: 'click_compra_ahora',
    CLICK_REGISTRATION_MAIN_BANNER: 'click_registration_main_banner',
    CLICK_REGISTRATION_MINI_BANNER: 'click_registration_mini_banner',
    CLICK_REGISTRATION_MID_BANNER: 'click_registration_mid_banner',
    CLICK_REGISTRATION_NOTIFICATION: 'click_registration_notification',
    /** The "sign up and save" card in the cart and the quick-order modal. */
    CLICK_REGISTRATION_CART: 'click_registration_cart',
    /** Every time the cart grows: the first add of a product, or a bigger quantity. */
    ADD_TO_CART: 'add_to_cart',
    /** The quick-order modal's thank-you screen (the order was created). */
    FAST_CLAIM_CREATED: 'fast_claim_created',
    /** The cart checkout's thank-you screen (the order was created). */
    CART_CLAIM_CREATED: 'cart_claim_created',
} as const;

/** Events sent to Google Analytics only (`sendGaEvent`); Metrika doesn't get them. */
export const GA_EVENTS = {
    /** Every time the quick-order modal is shown. */
    OPEN_FAST_CLAIM: 'open_fast_claim',
} as const;

export const GOOGLE_ANALYTICS_IDS: Record<string, string> = {
    CO: 'G-15PT4X8YBJ',
    ES: 'G-G2L0JDEHH3',
    MX: 'G-9Y85NE5WDS',
    CR: 'G-JY3WS4D432',
    GT: 'G-BLE1L7EMRW',
};

export const YANDEX_METRIKA_IDS: Record<string, string> = {
    CO: '110908818',
    ES: '110963333',
    MX: '112814562',
    CR: '113467096',
    GT: '113467191',
};
